import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetPartnerAgreementPdfParams } from "./getPartnerAgreementPdf.schema";

export const getPartnerAgreementPdf =
  (axios: IAxiosInstance) => async (params: TGetPartnerAgreementPdfParams) => {
    const response = await axios.noRetry.get<Blob>(
      `/partners/pdf/${params.document_key}/${params.partnerID}/form.pdf?accessToken=${params.accessToken}`,
      {
        responseType: "blob",
        headers: { Authorization: `Bearer ${params.accessToken}` },
      }
    );

    if (!response.data) {
      throw new Error("Failed to download partner agreement PDF");
    }

    return response.data;
  };
